import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class CurrencyItems {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string | null;
  @IsString()
  @Expose()
  code!: string | null;
  @IsBoolean()
  @Expose()
  autoUpdate!: boolean | null;

  constructor(
    id: number | number = 0,
    name: null | string = "",
    code: null | string = "",
    autoUpdate: null | boolean = false
  ) {
    (this.id = id), (this.name = name), (this.code = code), (this.autoUpdate = autoUpdate);
  }
}

export class CurrencyItemsResponse extends GenericTableResponse<CurrencyItems> {
  @Expose()
  @IsArray()
  @Type(() => CurrencyItems)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<CurrencyItems>;
}
